import { overrides } from 'vue-tour/.eslintrc'
import AbstractService from '@/services/abstractService'

class InvoiceService extends AbstractService {
    endpoint = '/invoices';

    index(contractId) {
      return this.http.get(`contracts/${contractId}${this.endpoint}`, { params: { dashboard: true } })
    }

    post(contractId, data) {
      console.log('data', data)
      // define append form
      const formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.post(`contracts/${contractId}${this.endpoint}`, formData)
    }

    put(contractId, invoiceId, data) {
      console.log('dataggg', data)
      // define append form
      const formData = new FormData()
      for (const key in data) {
        if (data[key] === null) {
          formData.append(key, '')
        } else {
          formData.append(key, data[key])
        }
      }
      return this.http.put(`contracts/${contractId}${this.endpoint}/${invoiceId}`, formData)
    }

  delete(contractId, data) {
    return this.http.delete(`contracts/${contractId}${this.endpoint}/${data}`)
  }
}

const Service = new InvoiceService()

export default Service
